// extracted by mini-css-extract-plugin
module.exports = {"container":"AddStaff_container__1ZJRy"};